import { DomainLayout } from "@/components/layouts/DomainLayout";
import { SavingPocketsView } from "../views/SavingPocketsView";

export const SavingPocketsPage = () => {
  return (
    <DomainLayout>
      <SavingPocketsView />
    </DomainLayout>
  );
};
